import React from 'react'
// @ts-ignore esModuleInterop
import { Breadcrumb as SemanticBreadcrumb } from '@adc/ui-core'
import classnames from 'classnames/bind'
import styles from './styles.scss'
const cx = classnames.bind(styles)

export interface BreadcrumbProps {
  crumbs: React.ReactNode[]
  className: string
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ crumbs = [], className }) => (
  <SemanticBreadcrumb className={cx('breadcrumb', className)} size='small'>
    {crumbs.map((crumb, index) =>
      index !== crumbs.length - 1 ? (
        <span key={index}>
          <SemanticBreadcrumb.Section>{crumb}</SemanticBreadcrumb.Section>
          <SemanticBreadcrumb.Divider icon='right angle' />
        </span>
      ) : (
        <span key={index}>
          <SemanticBreadcrumb.Section active key={index}>
            {crumb}
          </SemanticBreadcrumb.Section>
        </span>
      )
    )}
  </SemanticBreadcrumb>
)

export default Breadcrumb
